<div
  class="preclinical flex flex-col w-full bg-background-tertiary"
  [class.expanded-view]="isExpanded"
  [class.gap-6]="!isExpanded"
  [class.py-6]="!isExpanded"
  [class.min-h-screen]="!isExpanded"
  [class.h-screen]="isExpanded"
  [class.p-0]="isExpanded"
>
  <div
    class="header-section flex flex-col"
    [class.gap-6]="!isExpanded"
    [class.px-8]="isExpanded"
    [class.py-6]="isExpanded"
    [class.gap-3]="isExpanded"
  >
    <div class="flex flex-col gap-2">
      <h3 class="text-2xl font-bold text-brand-tertiary m-0">Observaciones</h3>
      <p class="text-sm text-text-secondary m-0">
        Visualiza las muestras que al ingresar tienen una observación,
        incluyendo los reprocesos, aquí le puedes dar seguimiento, editarlas o
        eliminarlas.
      </p>
    </div>

    <div class="tabs-container flex border-b border-border-secondary">
      <button
        type="button"
        class="tab-button flex items-center gap-2 px-6 py-3 text-sm font-medium transition-colors"
        [class.tab-active]="isTabActive('preclinical')"
        [class.tab-inactive]="!isTabActive('preclinical')"
        (click)="onTabChange('preclinical')"
      >
        <i class="icon-persona-pizarra-azul w-6 h-6"></i>
        Preanalítica
      </button>
      <button
        type="button"
        class="tab-button flex items-center gap-2 px-6 py-3 text-sm font-medium transition-colors"
        [class.tab-active]="isTabActive('laboratory')"
        [class.tab-inactive]="!isTabActive('laboratory')"
        (click)="onTabChange('laboratory')"
      >
        <i class="icon-muestras-azul w-6 h-6"></i>
        Laboratorio
      </button>
    </div>

    @if (dashboardMetrics().length > 0) {
      <app-metrics-dashboard
        [metrics]="dashboardMetrics()"
      ></app-metrics-dashboard>
    }

    <div class="flex flex-col gap-4">
      <div class="flex justify-between items-center gap-4 flex-wrap">
        <div class="flex gap-4">
          <app-button
            label="Exportar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="openExportModal()"
          >
          </app-button>
          <app-button
            label="Filtrar"
            leftIcon="icon-filtro"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleFilterSidebar()"
          >
          </app-button>
          <app-button
            label="Buscar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleSearchControls()"
          >
          </app-button>
          <app-button
            label="Inmovilizar"
            [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
            [size]="ButtonSizeEnum.MD"
            (handleClick)="toggleFrozenColumnsSidebar()"
          >
          </app-button>
        </div>

        <button
          (click)="toggleExpansion()"
          class="w-10 h-10 min-w-10 min-h-10 border-none bg-transparent cursor-pointer p-0 flex-shrink-0"
          [class.icon-expandir-vista]="!isExpanded"
          [class.icon-contraer-vista]="isExpanded"
          [attr.aria-label]="isExpanded ? 'Contraer vista' : 'Expandir vista'"
          type="button"
        ></button>
      </div>

      @if (showSearchControls()) {
        <div class="search-controls-container animate-fade-in">
          <app-search-controls
            [searchFieldOptions]="searchFieldOptions"
            (searchExecuted)="handleSearch($event)"
            (clear)="handleClearSearch()"
          ></app-search-controls>
        </div>
      }

      @if (hasActiveFilters) {
        <app-active-filters
          [filterCriteria]="currentFilterCriteria"
          (clearFilters)="clearFilters()"
        ></app-active-filters>
      }
    </div>
  </div>

  <div
    class="flex flex-col table-container min-h-0"
    [class.flex-1]="isExpanded"
    [class.overflow-hidden]="isExpanded"
  >
    @if (isLoading()) {
      <div class="flex items-center justify-center py-16 flex-1">
        <div class="flex flex-col items-center gap-4">
          <div
            class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"
          ></div>
          <span class="text-gray-500">Cargando observaciones...</span>
        </div>
      </div>
    } @else {
      <app-table
        [items]="observations()"
        [visibleColumns]="visibleColumnsComputed()"
        [frozenColumns]="frozenColumnsInOrder()"
        [tableName]="'Observaciones'"
        [tableActions]="tableActions"
        [showCheckboxes]="false"
        [itemIdField]="'observationId'"
      >
      </app-table>
    }

    <app-paginator
      [totalRegister]="totalRecords()"
      (getData)="onPageChange($event)"
    >
    </app-paginator>
  </div>
</div>

<app-frozen-columns-sidebar
  [columns]="availableColumns"
  [isOpen]="isFrozenSidebarOpen"
  (closeSidebar)="closeFrozenColumnsSidebar()"
></app-frozen-columns-sidebar>

@if (activeTab() === 'preclinical') {
  <app-filter-sidebar
    [isOpen]="isFilterSidebarOpen"
    [hiddenFilters]="['priority', 'region', 'examType', 'site', 'sampleType', 'facility']"
    [filterOptionsService]="getFilterOptionsService()"
    [currentFilters]="currentFilterCriteria"
    (closeSidebar)="closeFilterSidebar()"
    (applyFilters)="handleApplyFilters($event)"
  ></app-filter-sidebar>
}

@if (activeTab() === 'laboratory') {
  <app-filter-sidebar
    [isOpen]="isFilterSidebarOpen"
    [hiddenFilters]="['priority', 'region', 'examType', 'site', 'sampleType', 'facility']"
    [filterOptionsService]="getFilterOptionsService()"
    [currentFilters]="currentFilterCriteria"
    (closeSidebar)="closeFilterSidebar()"
    (applyFilters)="handleApplyFilters($event)"
  ></app-filter-sidebar>
}

<app-export-confirmation-modal
  [isOpen]="isExportModalOpen()"
  [state]="exportModalState()"
  (confirm)="handleExportConfirm()"
  (closeModal)="closeExportModal()"
></app-export-confirmation-modal>

@if (isEditModalOpen() && selectedObservation()) {
  <app-observation-edit-modal
    [observation]="selectedObservation()!"
    (closeModal)="closeEditModal()"
    (statusUpdated)="onStatusUpdated()"
  ></app-observation-edit-modal>
}

@if (isHistoryModalOpen() && selectedObservation()) {
  <app-observation-history-modal
    [observation]="selectedObservation()!"
    (closeModal)="closeHistoryModal()"
    (historyAdded)="onHistoryAdded()"
  ></app-observation-history-modal>
}
